module.exports = __webpack_public_path__ + "img/articles-mobile@3x.6b98fca.png";